import script from "./RfidProcessingSelectionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RfidProcessingSelectionPage.vue?vue&type=script&setup=true&lang=js"

import "./RfidProcessingSelectionPage.vue?vue&type=style&index=0&id=7b797853&lang=css"
import "./RfidProcessingSelectionPage.vue?vue&type=style&index=1&id=7b797853&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b797853"]])

export default __exports__